export const NARRATIVE_EASTER_EGG_FEATURE_FLAG = "narrative-easter-egg";

/**
 * Per-station WorkOS flag gating the "🔍 Highlight Easter Egg" finder — the
 * hint button that scrolls to and flashes the inserted phrase. Strictly a
 * sub-feature of `narrative-easter-egg`: BOTH flags must be on for the finder
 * to appear, so a station can run the read-verification gate without handing
 * officers a shortcut past it. Toggled online in WorkOS; flags arrive with the
 * auth context at login, so no redeploy is needed.
 */
export const NARRATIVE_EASTER_EGG_FINDER_FEATURE_FLAG =
  "narrative-easter-egg-finder";

export function isNarrativeEasterEggEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(NARRATIVE_EASTER_EGG_FEATURE_FLAG);
}

/**
 * Pure flag check — no auth context, for tests and non-hook callers. Reports
 * only the finder flag; callers must AND it with isNarrativeEasterEggEnabled.
 */
export function isNarrativeEasterEggFinderEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(
    NARRATIVE_EASTER_EGG_FINDER_FEATURE_FLAG,
  );
}
